/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Ref_IntroInputs */

const en_diff_ref_intro = /** @type {(inputs: Diff_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three markers and a path syntax. Nothing else appears in the result panel.`)
};

const ko_diff_ref_intro = /** @type {(inputs: Diff_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세 가지 표식과 하나의 경로 문법입니다. 결과 패널에는 그 밖의 것이 나오지 않습니다.`)
};

const ja_diff_ref_intro = /** @type {(inputs: Diff_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 つの記号と 1 つのパス構文です。結果パネルにはそれ以外は出ません。`)
};

/**
* | output |
* | --- |
* | "Three markers and a path syntax. Nothing else appears in the result panel." |
*
* @param {Diff_Ref_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_ref_intro = /** @type {((inputs?: Diff_Ref_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Ref_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_ref_intro(inputs)
	if (locale === "ko") return ko_diff_ref_intro(inputs)
	return ja_diff_ref_intro(inputs)
});